import reducer from './reducer';

export { userInteraction as sliceId } from '../registry';

export * from './actionCreators';
export * from './selectors';

export default reducer;
